<template>
  <div class="emoji-container">
    <button
        @click="prev"
        class="button left"
        :disabled="answered">

    </button>
    <div class="img-container" :class="{wrong : answered && !correct}">
      <img :src="image" alt=""></div>
    <button class="button right"
            @click="next"
            :disabled="answered">

    </button>
  </div>
</template>

<script>
export default {
  name: "EmojiChecker",
  props: ["variants", "answered", "correct"],
  created() {
    this.$emit("update", this.currentValue, true);
  },
  data() {
    return {
      currentIndex: 0
    };
  },
  computed: {
    image() {
      return `/img/emojis/${this.currentValue}.png`;
    },
    currentValue() {
      return this.variants[this.currentIndex];
    }
  },
  methods: {
    next() {
      if (this.currentIndex + 1 < this.variants.length) {
        this.currentIndex++;
      } else {
        this.currentIndex = 0;
      }
    },
    prev() {
      if (this.currentIndex - 1 >= 0) {
        this.currentIndex--;
      } else {
        this.currentIndex = this.variants.length - 1;
      }
    }
  },
  watch: {
    currentIndex: function() {
      this.$emit("update", this.currentValue);
    },
    variants: function() {
      this.$emit("update", this.currentValue);
    }
  }
};
</script>

<style scoped lang="scss">
.emoji-container {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  min-width: 75px;
  padding-left: 5px;
  padding-right: 5px;
  height: 48px;
  img {
    max-height: 36px;
    max-width: 36px;
  }
  .img-container {
    display: flex;
    align-items: center;
    width: 48px;
    height: 48px;
    justify-content: center;
  }
}

.wrong {
  background-image: url("../assets/x.png");
  background-position: center center;
  background-repeat: no-repeat;
}

.button {
  background-color: transparent;
  background-repeat: no-repeat;
  border: 0;
  width: 10px;
  height: 15px;
  cursor: pointer;
  &:focus {
    outline: 0;
  }

  &.left {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='9px' height='15px'%3e%3cpath fill-rule='evenodd' fill='rgb(0, 71, 255)' d='M0.010,7.689 L8.298,0.370 L8.298,15.007 L0.010,7.689 Z'/%3e%3c/svg%3e");
  }
  &:disabled.left {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='9px' height='15px'%3e%3cpath fill-rule='evenodd' fill='rgb(230, 230, 230)' d='M0.010,7.689 L8.298,0.371 L8.298,15.007 L0.010,7.689 Z'/%3e%3c/svg%3e");
  }
  &:disabled.right {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='9px' height='15px'%3e%3cpath fill-rule='evenodd' fill='rgb(230, 230, 230)' d='M8.998,7.236 L0.469,-0.007 L0.469,14.478 L8.998,7.236 Z'/%3e%3c/svg%3e");
  }
  &.right {
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='9px' height='15px'%3e%3cpath fill-rule='evenodd' fill='rgb(0, 71, 255)' d='M8.998,7.236 L0.469,-0.007 L0.469,14.478 L8.998,7.236 Z'/%3e%3c/svg%3e");
  }
}
</style>
